import { Button, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { Loader } from '@googlemaps/js-api-loader';

// @styles
import './styles.scss'

export default function Location({ data }) {
    const [visible, setVisible] = useState(false);
    const [img, setImg] = useState('');

    useEffect(() => {
        const loader = new Loader({
            apiKey: process.env.REACT_APP_MAP_API_KEY
        });
        loader.load().then((google) => {
            new google.maps.Map(document.getElementById("map"), {
                center: { lat: 19.432241, lng: -99.177254 },
                zoom: 8,
            });
        }).catch(e => { });
    }, [visible]);

    useEffect(() => {
        const img = data && data.primary && data.primary.image && data.primary.image.url.split("?")[0];
        setImg(img);
    }, []);

    return (
        <>
            <div className="location__container">
                <div className='location__container-content'>
                    <div className='location__container-content-text'>
                        <div className='location__container-content-text-title'>
                            {data.primary.title}
                        </div>
                        <div className='location__container-content-text-image'>
                            <img
                                src={img}
                                alt={data.primary.title}
                            />
                        </div>
                        {data.primary.geosura && (
                            <Button
                                className='ant-btn-solid c-3'
                                onClick={() => setVisible(true)}
                            >
                                <strong> {data.primary.buttonlabel}</strong>
                            </Button>
                        )}
                    </div>
                </div>
            </div>

            <Modal
                title={data.primary.servicetitle}
                visible={visible}
                width='900px'
                centered
                footer=''
                onCancel={() => setVisible(false)}
                wrapClassName='modal-geosura'
            >
                <div id="map" style={{ height: '100%' }}></div>
            </Modal>
        </>
    )
}